import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/ErrorBoundary";

// Comprehensive ResizeObserver error suppression
// These are benign errors from Radix UI components and don't affect functionality

// 1. Suppress via window error handler
window.addEventListener('error', e => {
  if (e.message && e.message.includes('ResizeObserver')) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// 2. Suppress unhandledrejection for ResizeObserver
window.addEventListener('unhandledrejection', e => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver')) {
    e.preventDefault();
    return false;
  }
});

// 3. Suppress via console.error override
const originalError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === 'string' && args[0].includes('ResizeObserver')) {
    return;
  }
  originalError.apply(console, args);
};

// 4. Debounce ResizeObserver if available
if (typeof ResizeObserver !== 'undefined') {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

// 5. Suppress React DevTools error overlay
if (process.env.NODE_ENV === 'development') {
  const originalReportError = window.reportError || console.error;
  window.reportError = (...args) => {
    if (args[0] && args[0].message && args[0].message.includes('ResizeObserver')) {
      return;
    }
    originalReportError.apply(window, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
